export function colorToken(value) {
  return `var(--${value})`;
}